module.exports = __webpack_public_path__ + "static/media/my-process.8c47b3ef.jpg";